import React, { FormEventHandler, useState } from 'react';

import { Button, DialogActions, DialogContent } from '@mui/material';

import { VARIANT_OF_REFUND_SURCHARGE } from '~/consts/refund';

import { CollectionReason } from '../../types';
import CaseIDAndReasons from '../Common/CaseIDAndReasons';
import MarkCancelled from '../Common/MarkCancelled';

import SelectRefundVariantWithSurcharge from './SelectRefundVariantWithSurcharge';

interface Props {
  currencyCode?: string;
  decrementStep: () => void;
  defaultCaseId: string;
  defaultComment: string;
  hasSurcharge?: boolean;
  onSubmit: FormEventHandler<HTMLFormElement>;
  reason: CollectionReason;
  surchargeAmount?: number;
  disablePartialRefund?: boolean;
  onSurchargeToggleChange?: (value: boolean) => void;
  groupRefundCeiling?: number;
}

export default function PackageAmendment({
  currencyCode,
  decrementStep,
  defaultCaseId,
  defaultComment,
  hasSurcharge = false,
  onSubmit,
  reason,
  surchargeAmount,
  disablePartialRefund = false,
  onSurchargeToggleChange,
  groupRefundCeiling,
}: Props) {
  const [variantOfRefund, setVariantOfRefund] = useState<string>();

  return (
    <>
      <DialogContent dividers>
        <form onSubmit={onSubmit} id="package-amendment-form">
          <CaseIDAndReasons reason={reason} defaultComment={defaultComment} defaultCaseId={defaultCaseId} />
          <SelectRefundVariantWithSurcharge
            hasSurcharge={hasSurcharge}
            currencyCode={currencyCode}
            surchargeAmount={surchargeAmount}
            variantOfRefund={variantOfRefund}
            setVariantOfRefund={setVariantOfRefund}
            disablePartialRefund={disablePartialRefund}
            onSurchargeToggleChange={onSurchargeToggleChange}
            defaultShouldSurchargeBeRefunded="true"
            groupRefundCeiling={groupRefundCeiling}
          />
          {variantOfRefund && <input type="hidden" name="variantOfRefund" value={variantOfRefund} />}
          {variantOfRefund !== VARIANT_OF_REFUND_SURCHARGE && <MarkCancelled />}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={decrementStep}>Back</Button>
        <Button type="submit" variant="contained" form="package-amendment-form">
          Continue
        </Button>
      </DialogActions>
    </>
  );
}
